import { render, staticRenderFns } from "./pembeliaan.vue?vue&type=template&id=bd9b5212&"
import script from "./pembeliaan.vue?vue&type=script&lang=js&"
export * from "./pembeliaan.vue?vue&type=script&lang=js&"
import style0 from "./pembeliaan.vue?vue&type=style&index=0&id=bd9b5212&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports